<!--
  Aviso de la campaña de referidos en el home.

  Plegada es una sola barra con el monto: quien no está interesado la pasa de
  largo sin que le haya costado nada. Desplegada trae lo justo para actuar
  —link, compartir y quién ya cargó— y el resto vive en el módulo completo.
-->
<section class="rh" *ngIf="visible" aria-labelledby="rh-titulo">

  <button
    type="button"
    class="rh__head"
    (click)="alternar()"
    [attr.aria-expanded]="!colapsada"
    aria-controls="rh-body"
  >
    <span class="rh__head-icon">
      <mat-icon>redeem</mat-icon>
    </span>
    <span class="rh__head-text">
      <span class="rh__head-title" id="rh-titulo">Invita y gana</span>
      <span class="rh__head-sub">{{ titulo }}</span>
    </span>
    <mat-icon class="rh__chev" [class.rh__chev--cerrado]="colapsada">
      expand_more
    </mat-icon>
  </button>

  <div id="rh-body" class="rh__body" *ngIf="!colapsada">

    <div class="rh__cargando" *ngIf="cargando">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Un momento…</span>
    </div>

    <p class="rh__fallo" *ngIf="fallo && !cargando">
      No pudimos cargar tus referidos. Cierra y vuelve a abrir para reintentar.
    </p>

    <ng-container *ngIf="cargado && !cargando">

      <p class="rh__sub" *ngIf="bonoInvitadoTexto && cargaTexto">
        Tu amigo gana {{ bonoInvitadoTexto }} cuando hace {{ cargaTexto }}.
      </p>

      <p class="rh__sub" *ngIf="fraseCondiciones">{{ fraseCondiciones }}</p>

      <!-- Sólo con tope. Sin tope no se dice nada: "te quedan infinitas" no
           le sirve a nadie. -->
      <p class="rh__restante" *ngIf="restante !== null">
        Te {{ restante === 1 ? 'queda' : 'quedan' }} {{ restante }}
        {{ restante === 1 ? 'invitación premiada' : 'invitaciones premiadas' }}.
      </p>

      <!-- La mecánica en tres pasos: responde "¿qué tengo que hacer?" sin un clic. -->
      <ol class="rh__pasos">
        <li><span class="rh__paso-n">1</span>Comparte tu link</li>
        <!-- «La condición» sólo si la línea de arriba la dice; si no, sería
             nombrar algo que no está en pantalla. -->
        <li><span class="rh__paso-n">2</span>Tu amigo se registra y {{ cargaTexto ? 'cumple la condición' : 'carga' }}</li>
        <li class="rh__paso--gana"><span class="rh__paso-n">3</span>Ganan los dos</li>
      </ol>

      <!-- Sin llave todavía. El alta es para siempre y su confirmación vive en
           un solo lugar: desde acá se va al módulo, no se duplica el formulario. -->
      <div class="rh__sinllave" *ngIf="!llave">
        <p>
          Para invitar necesitas tu usuario de Aguacate. Lo eliges una vez y es
          el que vas a compartir.
        </p>
        <a class="rh__btn" routerLink="/wallet/client/referidos">
          <mat-icon>badge</mat-icon>Crear mi usuario
        </a>
      </div>

      <ng-container *ngIf="llave">

        <div class="rh__link">
          <span class="rh__link-label">Tu link de invitación</span>
          <div class="rh__link-row">
            <b class="rh__link-url" [title]="link">{{ link }}</b>
            <button
              type="button"
              class="rh__copiar"
              (click)="copiarLink()"
              aria-label="Copiar mi link de invitación"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>

        <div class="rh__acciones">
          <button type="button" class="rh__btn" (click)="compartirWhatsapp()">
            <mat-icon>chat</mat-icon>Compartir por WhatsApp
          </button>
          <button type="button" class="rh__btn rh__btn--ghost" (click)="copiarLink()">
            <mat-icon>content_copy</mat-icon>Copiar link
          </button>
        </div>

        <div class="rh__kpis" *ngIf="resumen">
          <div>
            <b>{{ ganadoTexto }}</b>
            <span>Ganados</span>
          </div>
          <div>
            <b>{{ resumen.invitadosQueFondearon }}</b>
            <span>Ya cargaron</span>
          </div>
          <div>
            <b>{{ enProceso }}</b>
            <span>En proceso</span>
          </div>
        </div>

        <!-- El bono propio: el de quien entró con la llave de otro. Se dice
             qué le falta con el texto que redacta el backend, no uno de acá. -->
        <p class="rh__mibono" *ngIf="resumen?.miBono?.falta">
          Tu bono de {{ resumen?.miBono?.montoUsdt }} {{ resumen?.miBono?.moneda }}:
          {{ resumen?.miBono?.falta }}
        </p>

        <ul class="rh__lista" *ngIf="ultimos.length">
          <li *ngFor="let r of ultimos; trackBy: trackReferido">
            <span class="rh__av">{{ inicial(r) }}</span>
            <span class="rh__quien">
              <b>{{ r.nombre }}</b>
              <u [title]="estado(r)">{{ estado(r) }}</u>
            </span>
            <span class="rh__chip" [ngClass]="chip(r).clase">{{ chip(r).texto }}</span>
          </li>
        </ul>

        <p class="rh__vacio" *ngIf="!ultimos.length">
          Todavía no has invitado a nadie. Comparte tu link para empezar.
        </p>

      </ng-container>

      <a class="rh__todos" routerLink="/wallet/client/referidos">
        Ver mi usuario y referidos →
      </a>

    </ng-container>
  </div>
</section>
